<template>
  <div id="dashboard">
    <h3>Dashboard</h3>
    <ul class="collection with-header">
      <li class="collection-header">
        <h4>Empleados</h4>
      </li>
      <li v-for="empleado in empleados" v-bind:key="empleado.id" class="collection-item">
        <div class="chip">{{empleado.area}}</div>
        {{empleado.empleado_id}}:{{empleado.nombre}}
        <!--las llaves porq vamos a pasar un parametro-->
        <router-link class="secondary-content" v-bind:to="{name:'view-empleado', params:{empleado_id:empleado.empleado_id}}">
            <i class="fa fa-eye"></i>
        </router-link>
      </li>
    </ul>
    <div class="fixed-action-btn">
      <router-link to="/new" class="btn-floating btn-large red">
        <i class="fa fa-plus"></i>
      </router-link>
    </div>
  </div>
</template>
<script>
import db from "./firebaseInit";

export default {
  name: "dashboard",
  data() {
    return {
      empleados: []
    };
  },
  created() {
    db.collection("empleados")
      .orderBy('area')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          //console.log(doc.id);
          const data = {
            'id': doc.id,
            'empleado_id': doc.data().empleado_id,
            'nombre': doc.data().nombre,
            'area': doc.data().area,
            'posicion': doc.data().posicion
          };
          this.empleados.push(data);
        });
      });
  }
};
</script>

